const BookingCTA = () => {
  return (
    <section className="bg-charcoal py-16 px-6">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <h3 className="text-2xl font-semibold text-white font-sans">
          Book your next appointment
        </h3>
        <a
          href="/contact"
          className="inline-flex items-center gap-2 px-8 py-3 bg-sage text-white font-sans text-base font-medium rounded-full hover:bg-sage-light transition-all whitespace-nowrap cursor-pointer"
        >
          <i className="ri-phone-line"></i>
          Book Now
        </a>
      </div>
    </section>
  );
};

export default BookingCTA;